module.exports = "/fonts/Raleway-Medium.ttf?430a0518f5ff3b6c8968b759a29b36e2";